import z from 'zod';

export const userCrumbTypeSchema = z.enum(['checkin', 'checkout']);

export const userCrumbSchema = z
	.object({
		id: z.string(),
		userId: z.string(),
		type: userCrumbTypeSchema.optional(),
		timestamp: z.coerce.date().optional(),
		zoneId: z.string().optional(),
		eventId: z.string().optional(),
		logId: z.string().optional(),
		data: z.any().optional(),
		latest: z.boolean().optional(),
		createdAt: z.coerce.date().optional(),
		updatedAt: z.coerce.date().optional(),
	})
	.describe('UserCrumb');
